import { getRandomAlphaNumString } from '@jfs/utils'
import { Platform } from 'react-native'
import { Config } from 'react-native-config'
import DeviceInfo from 'react-native-device-info'
import { generateRandomString, getDeviceInfo } from '../util/util'

export let BASE_URL = ''
export let CHANNEL_ID = ''

const { REACT_APP_JFS_CHANNEL_ID = '' } = (window?._env_ ?? {})

if (Platform.OS === 'android' || Platform.OS === 'ios') {
  BASE_URL = Config.REACT_APP_BASE_URL ?? ''
  CHANNEL_ID = Config.REACT_APP_CHANNEL_ID ?? ''
} else {
  BASE_URL = window?._env_?.REACT_APP_BASE_URL ?? ''
  CHANNEL_ID = window?._env_?.REACT_APP_CHANNEL_ID ?? ''
}

let header = {
  'x-channel-id': REACT_APP_JFS_CHANNEL_ID,
  'Content-Type': 'application/json',
}

export const setHeader = (newHeader: any) => {
  header = newHeader
}

export const getHeader = () => {
  return { ...header, 'x-trace-id': getRandomAlphaNumString(16) ?? '' }
}

export const sitConfig = (token: any, abortController?: any) => {
  const { appAccessToken, appIdToken, userAccessToken, userIdToken } = token
  return {
    baseUrl: `${BASE_URL}`,
    headers: {
      'Content-Type': 'application/json',
      'X-Channel-ID': CHANNEL_ID,
      'x-trace-id': generateRandomString(20),
      'x-api-key': 'dummy',
      // 'X-DEVICE-INFO': getDeviceInfo(mobileNumber),
      'x-app-access-token': appAccessToken || '', //not required.
      'x-appid-token': appIdToken || '',
      'x-user-access-token': userAccessToken || '',
      'x-userid-token': userIdToken || '',
    },
    retryCount: 0,
    abortController,
  }
}

export const sitConfigQrAgentPortal = (token: any) => {
  const { appAccessToken, appIdToken, userAccessToken, userIdToken } = token
  return {
    baseUrl: `${BASE_URL}`,
    timeOut: 60000,
    headers: {
      'Content-Type': 'application/json',
      'X-Channel-ID': CHANNEL_ID,
      'x-trace-id': generateRandomString(20),
      'x-api-key': 'dummy',
      // 'X-DEVICE-INFO': getDeviceInfo(mobileNumber),
      'x-app-access-token': appAccessToken || '', //not required.
      'x-appid-token': appIdToken || '',
      'x-user-access-token': userAccessToken || '',
      'x-userid-token': userIdToken || '',
    },
    retryCount: 0,
  }
}

export const sitConfigUserManagement = (token: any) => {
  const { appAccessToken, appIdToken, userAccessToken, userIdToken } = token
  return {
    baseUrl: `${BASE_URL}`,
    headers: {
      'Content-Type': 'application/json',
      'X-Channel-ID': 6163,
      'x-trace-id': generateRandomString(20),
      'x-api-key': 'dummy',
      // 'X-DEVICE-INFO': getDeviceInfo(mobileNumber),
      'x-app-access-token': appAccessToken || '', //not required.
      'x-appid-token': appIdToken || '',
      'x-user-access-token': userAccessToken || '',
      'x-userid-token': userIdToken || '',
    },
    retryCount: 0,
  }
}

export const userDeviceConfig = (token: any) => {
  const { appAccessToken, appIdToken, userAccessToken, userIdToken } = token
  return {
    baseUrl: `${BASE_URL}`,
    headers: {
      'Content-Type': 'application/json',
      'X-Channel-ID': CHANNEL_ID,
      'x-trace-id': generateRandomString(20),
      'x-api-key': 'dummy',
      'X-DEVICE-INFO': JSON.stringify({
        os: `${Platform.OS}-${DeviceInfo.getSystemVersion()}`,
        appVersion: DeviceInfo.getVersion() ?? '1.2.8',
      }),
      'x-app-access-token': appAccessToken || '', //not required.
      'x-appid-token': appIdToken || '',
      'x-user-access-token': userAccessToken || '',
      'x-userid-token': userIdToken || '',
    },
    retryCount: 0,
  }
}

export const sitConfigPreAuth = (token: any) => {
  const { appAccessToken, appIdToken } = token
  return {
    baseUrl: `${BASE_URL}`,
    headers: {
      'Content-Type': 'application/json',
      'X-Channel-ID': CHANNEL_ID,
      'x-api-key': 'dummy',
      'x-trace-id': generateRandomString(20),
      'x-app-access-token': appAccessToken || '',
      'x-appid-token': appIdToken || '',
    },
    retryCount: 0,
  }
}

export const bankConfig = (token: any, useSit?: boolean) => {
  const { appAccessToken, appIdToken, userAccessToken, userIdToken } = token
  return {
    baseUrl: useSit ? BASE_URL : 'http://10.140.138.12:3006',
    headers: {
      'Content-Type': 'application/json',
      'X-Channel-ID': CHANNEL_ID,
      'x-trace-id': generateRandomString(20),
      'x-api-key': 'dummy',
      'x-app-access-token': appAccessToken || '',
      'x-appid-token': appIdToken || '',
      'x-user-access-token': userAccessToken || '',
      'x-userid-token': userIdToken || '',
    },
    retryCount: 0,
  }
}

export const sitConfigWithAuthCred = (token: any, mobileNumber?: string) => {
  const { appAccessToken, appIdToken, userAccessToken, userIdToken } = token
  return {
    baseUrl: `${BASE_URL}`,
    headers: {
      'Content-Type': 'application/json',
      'x-channel-id': CHANNEL_ID,
      'x-trace-id': generateRandomString(20),
      'X-DEVICE-INFO': getDeviceInfo(mobileNumber),
      'x-app-access-token': appAccessToken || '',
      'x-appid-token': appIdToken || '',
      'x-user-access-token': userAccessToken || '',
      'x-jwt-token': 'adada',
      'x-api-key': 'asdad',
      'x-access-token': '2103',
      'x-userid-token': userIdToken || '',
    },
    retryCount: 0,
  }
}

export const sitConfigIFSC = (token: any) => {
  const { appAccessToken, appIdToken, userAccessToken, userIdToken } = token
  return {
    baseUrl: `${BASE_URL}`,
    headers: {
      'Content-Type': 'application/json',
      'x-channel-id': CHANNEL_ID,
      'x-trace-id': generateRandomString(20),
      'x-app-access-token': appAccessToken || '',
      'x-appid-token': appIdToken || '',
      'x-user-access-token': userAccessToken || '',
      'x-jwt-token': 'adada',
      'x-api-key': 'asdad',
      'x-access-token': '2103',
      'x-userid-token': userIdToken || '',
    },
    retryCount: 0,
  }
}

export const usrSessionRefreshConfig = (appAccessToken: string, appIdToken: string) => {
  return {
    baseUrl: `${BASE_URL}`,
    headers: {
      'Content-Type': 'application/json',
      'X-Channel-ID': CHANNEL_ID,
      'x-api-key': 'dummy',
      'X-Trace-ID': generateRandomString(20),
      'x-app-access-token': appAccessToken || '',
      'x-appid-token': appIdToken || '',
    },
    retryCount: 0,
  }
}

export const appSessionRefreshConfig = () => {
  return {
    baseUrl: `${BASE_URL}`,
    headers: {
      'Content-Type': 'application/json',
      'X-Channel-ID': CHANNEL_ID,
      'x-api-key': 'dummy',
      'X-Trace-ID': generateRandomString(20),
    },
    retryCount: 0,
  }
}

export const settlementApiConfig = (tokens: any) => {
  const { appAccessToken, appIdToken, userAccessToken, userIdToken } = tokens
  return {
    baseUrl: `${BASE_URL}`,
    headers: {
      'Content-Type': 'application/json',
      'X-Channel-ID': CHANNEL_ID,
      'X-Trace-ID': getRandomAlphaNumString(20),
      'x-api-key': 'dummy',
      'x-app-access-token': appAccessToken || '',
      'x-appid-token': appIdToken || '',
      'x-user-access-token': userAccessToken || '',
      'x-userid-token': userIdToken || '',
    },
    retryCount: 0,
    cache: false,
  }
}

export const merchantConfig = (token: any) => {
  const { appAccessToken, appIdToken, userAccessToken, userIdToken } = token
  return {
    baseUrl: `${BASE_URL}`,
    headers: {
      'Content-Type': 'application/json',
      'X-Channel-ID': CHANNEL_ID,
      'x-trace-id': generateRandomString(20),
      'x-api-key': 'dummy',
      'x-app-access-token': appAccessToken || '',
      'x-appid-token': appIdToken || '',
      'x-user-access-token': userAccessToken || '',
      'x-userid-token': userIdToken || '',
    },
    retryCount: 0,
  }
}

export const intentConfig = (token: any) => {
  const { appAccessToken, appIdToken, userAccessToken, userIdToken } = token
  return {
    baseUrl: `${BASE_URL}`,
    headers: {
      'Content-Type': 'application/json',
      'x-trace-id': generateRandomString(20),
      'X-Api-Key': 'MyJioApiKey',
      'X-Channel-ID': CHANNEL_ID,
      'x-app-access-token': appAccessToken || '',
      'x-appid-token': appIdToken || '',
      'x-user-access-token': userAccessToken || '',
      'x-userid-token': userIdToken || '',
    },
    retryCount: 0,
  }
}

export const summaryConfig = (token: any, mobile: string, abortController?: any) => {
  const { appAccessToken, appIdToken, userAccessToken, userIdToken } = token
  return {
    baseUrl: `${BASE_URL}`,
    headers: {
      'Content-Type': 'application/json',
      'X-Channel-ID': CHANNEL_ID,
      'x-api-key': 'dummy',
      'x-trace-id': generateRandomString(20),
      'x-app-access-token': appAccessToken || '',
      'x-user-access-token': userAccessToken || '',
      'x-appid-token': appIdToken || '',
      'x-userid-token': userIdToken || '',
      mobileNumber: mobile,
    },
    retryCount: 0,
    abortController,
  }
}

export const devSitConfig = (token: any) => {
  const { appAccessToken, appIdToken, userAccessToken, userIdToken } = token
  return {
    baseUrl: 'https://10.140.138.12:3001',
    headers: {
      'Content-Type': 'application/json',
      'X-Channel-ID': CHANNEL_ID,
      'x-trace-id': generateRandomString(20),
      'x-api-key': 'dummy',
      // 'X-DEVICE-INFO': getDeviceInfo(mobileNumber),
      'x-app-access-token': appAccessToken || '', //not required.
      'x-appid-token': appIdToken || '',
      'x-user-access-token': userAccessToken || '',
      'x-userid-token': userIdToken || '',
    },
    retryCount: 0,
  }
}
